"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveStreamingEntriesEntry = void 0;
var LiveStreamingEntriesEntry = (function () {
    function LiveStreamingEntriesEntry() {
    }
    LiveStreamingEntriesEntry.getAttributeTypeMap = function () {
        return LiveStreamingEntriesEntry.attributeTypeMap;
    };
    LiveStreamingEntriesEntry.discriminator = undefined;
    LiveStreamingEntriesEntry.attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastName",
            "baseName": "last_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstName",
            "baseName": "first_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastNameKana",
            "baseName": "last_name_kana",
            "type": "string",
            "format": ""
        },
        {
            "name": "firstNameKana",
            "baseName": "first_name_kana",
            "type": "string",
            "format": ""
        },
        {
            "name": "birthdate",
            "baseName": "birthdate",
            "type": "string",
            "format": ""
        },
        {
            "name": "postcode",
            "baseName": "postcode",
            "type": "string",
            "format": ""
        },
        {
            "name": "address",
            "baseName": "address",
            "type": "string",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "gender",
            "baseName": "gender",
            "type": "string",
            "format": ""
        },
        {
            "name": "platformMasterId",
            "baseName": "platform_master_id",
            "type": "number",
            "format": ""
        },
        {
            "name": "platformUrl",
            "baseName": "platform_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "selfAppeal",
            "baseName": "self_appeal",
            "type": "string",
            "format": ""
        },
        {
            "name": "entryRoute",
            "baseName": "entry_route",
            "type": "LiveStreamingEntriesEntryEntryRouteEnum",
            "format": ""
        },
        {
            "name": "authProvider",
            "baseName": "auth_provider",
            "type": "LiveStreamingEntriesEntryAuthProviderEnum",
            "format": ""
        },
        {
            "name": "authUid",
            "baseName": "auth_uid",
            "type": "string",
            "format": ""
        },
        {
            "name": "authEmail",
            "baseName": "auth_email",
            "type": "string",
            "format": ""
        },
        {
            "name": "friendId",
            "baseName": "friend_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "inflowRoute",
            "baseName": "inflow_route",
            "type": "LiveStreamingEntriesEntryInflowRouteEnum",
            "format": ""
        }
    ];
    return LiveStreamingEntriesEntry;
}());
exports.LiveStreamingEntriesEntry = LiveStreamingEntriesEntry;
//# sourceMappingURL=LiveStreamingEntriesEntry.js.map